class Richtext
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'richtext--bound'
            @.$readMoreButton = @.$el.querySelector '.richtext__read-more-button'

            @.open = true
            @.collapsed = @.$el.classList.contains 'richtext--read-more'
            @.readMore = @.$el.classList.contains 'richtext--read-more'

            @.$el.classList.add 'richtext--bound'
            @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        if @.$readMoreButton
            @.$readMoreButton.addEventListener 'read-more-button-state-toggle', (e) ->
                open = e.detail.active ? false
                self.ToggleReadMore open
                return
    
    ToggleReadMore: (open) ->
        if typeof open != "undefined" && typeof open != "null"
            @.collapsed = !open
        else
            @.collapsed = !@.collapsed
        if @.collapsed
            @.$el.classList.add 'richtext--collapsed'
            window.scrollTo {
                behavior: 'smooth'
                left: 0
                top: @.$el.getBoundingClientRect().top + document.documentElement.scrollTop - document.querySelector('.header').offsetHeight
            }
        else
            @.$el.classList.remove 'richtext--collapsed'
        return

BindRichtexts = ->
    document.querySelectorAll '.richtext:not(.richtext--bound)'
        .forEach (el) ->
            new Richtext el
            return
    return

window.addEventListener 'bind-components', BindRichtexts